import { makeStyles } from "@material-ui/styles";
import { Theme } from "@material-ui/core";
import { TracercoColours } from "./TracercoColours";

const headerPadding = "16px";

const headerBarStyles = makeStyles((theme: Theme) => ({
    root: {
        flexGrow: 1
    },
    headerLogo: {
        width: "180px",
        [theme.breakpoints.down("xs")]: {
            width: "120px"
        }
    },
    greeting: {
        fontSize: "14px",
        padding: "5px 5px 5px 5px"
    },
    usernameContainer: {
        textAlign: "right",
        color: TracercoColours.Grey,
        position: "relative"
    },
    responsiveMenuContainer: {
        position: "absolute",
        backgroundColor: theme.palette.background.default,
        width: "100%",
        zIndex: 2,
        borderBottom: "1px solid " + TracercoColours.PaleGrey
    },
    responsiveMenuRoot: {
        display: "block",
        paddingLeft: headerPadding,
        paddingTop: "10px",
        paddingBottom: "10px"
    },
    navigation: {
        display: "flex",
        justifyContent: "flex-end"
    },
    navigationContainer: {
        marginLeft: "auto"
    },
    userIcon: {
        marginLeft: "auto",
        color: theme.palette.primary.main
    },
    dehazeIcon: {
        color: theme.palette.primary.main
    },
    prefButton: {
        padding: 0,
        marginLeft: "12px"
    }
}));

export default headerBarStyles;
